<template>
    <div>
        <a target="_blank" href="https://api.whatsapp.com/send?phone=5519990060979&amp;text=Olá%20Rei%20do%20Guincho%20Campinas,%20Gostaria%20de%20solicitar%20um%20orçamento." class="btn b1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg>&nbsp;CHAME O GUINCHO AGORA!
</a>
  </div>
    <br><br><br><br><footer class="footer-section">
        <div class="container">
            <div class="footer-content">
                <div class="row">
                    <div>
                        <h3>Sobre Nós</h3>
                        <p>Rei do Guincho Campinas - <strong style="color:#f42e03">Especialistas em Reboque e Socorro Veicular 24/7</strong>. Estamos prontos para atender você com rapidez, eficiência e segurança em qualquer hora do dia ou da noite. Nossa equipe altamente treinada garante o transporte seguro do seu veículo, seja em situações emergenciais ou agendadas. Confie no Rei do Guincho, a melhor escolha para quem busca qualidade e profissionalismo em Campinas e região.</p>
                    </div>
                    <div>
                        <h3>Serviços</h3>
                        <ul class="servicos">
                            <li><router-link to="/guincho-para-carros/">Guincho para Carros</router-link></li>
                            <li><router-link to="/guincho-para-motos/">Guincho para Motos</router-link></li>
                            <li><router-link to="/guincho-para-equipamentos/">Guincho para Equipamentos</router-link></li>
                            <li><router-link to="/guincho-para-vans/">Guincho para Vans</router-link></li>
                            <li><router-link to="/guincho-para-empilhadeiras/">Guincho para Empilhadeiras</router-link></li>
                            <li><router-link to="/guincho-para-carros-antigos/">Guincho para Carros Antigos</router-link></li>
                        </ul>
                    </div>
                    <div>
                        <h3>Informações Do Negócio</h3>
                        <div class="contact-info">
                            <a target="_blank" href="https://api.whatsapp.com/send?phone=5519990060979&amp;text=Olá%20Rei%20do%20Guincho%20Campinas,%20Gostaria%20de%20solicitar%20um%20orçamento." class="icon-text">
        <i class="fab fa-whatsapp"></i>
        <span>(19) 9 9006-0979</span>
    </a>
                            <a target="_blank" href="tel:5519990060979" class="icon-text"><i class="fas fa-phone"></i><span>(19) 9 9006-0979</span></a>
                            <a target="_blank" href="mailto:contato@reidoguinchocampinas.com.br" class="icon-text"><i class="far fa-envelope-open"></i><span>contato@reidoguinchocampinas.com.br</span></a>
                            <img src="@/assets/cartoes.webp" width="300"/>
                        </div>
                    </div>
                </div>
            </div><br><br><br>
            <div class="copyright-area">
                <div class="">
                    <p>&copy; {{ year }} - Todos os direitos reservados</p>
                </div>

            </div>
        </div>
    </footer>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'FooterComponent',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.servicos1{
    display: flex;
    flex-wrap: wrap;
    li {
    min-width: 45%;
    @media only screen and (max-width: 600px) {
        min-width: 100%;
    }
}

}
a{
    color:#d5d5d5!important
}
i{
    padding: 7px
}
.footer-content{
    padding: 0 5px;
}
.icon {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 18px;
    margin-right: 5px;
    color: #d5d5d5;
    font-size: 10px;
    text-align: center;
    background-color: #f3f3f6;
    vertical-align: middle;
    border-radius: 50%;
}
.row {
    display: flex;
    position: relative;
    width: 95%;
    margin: 0 auto!important;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 6px;
    div{
        // background: #0dd134;
        width: calc(95%/3);
        @media only screen and (max-width: 600px) {
            width: 95%;
    }
    }
}
*{
    overflow: hidden!important;
}
h3 {
    @media only screen and (max-width: 600px) {
            font-size: 28px;
    }
    font-family: "Teko", Sans-serif;
    font-weight: 500;
    text-transform: uppercase;
    line-height: 58px;
    color:#f42f03
}
.footer-section {
    background: linear-gradient(10deg, rgba(0, 0, 0, 9), rgba(0, 0, 0, 0.9));;
    color: #d5d5d5;
    padding: 60px 0 2px 0;
}

.contact-info{
    min-width: 100%;
    .icon-text {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color:#d5d5d5!important
}
}

.contact-info .icon-text i {
    margin-right: 10px;
    font-size: 20px;
    color: #f42e03;
}

.subscribe-form input[type="email"] {
    width: 60%;
    padding: 12px;
    border: none;
    outline: none;
    font-size: 14px;
    background-color: #fff;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.subscribe-form button {
    padding: 12px 20px;
    border: none;
    cursor: pointer;
    background-color: #ea8500;
    height: 40.8px;
    margin-left: 2px;
    color: #d5d5d5;
    font-size: 16px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.subscribe-form button:hover {
    background-color: #e64906;
}

.footer-social-icon {
    margin-top: 20px;
}

.footer-social-icon span {
    display: block;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
}

.footer-social-icon a {
    color: #d5d5d5;
    font-size: 20px;
    margin-right: 10px;
}

.footer-social-icon a:hover {
    color: #f42e03;
}

.footer-menu {
    display: flex;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center
}

.footer-menu li {
    margin: 0 10px;
}

.footer-menu li a {
    color: #d5d5d5;
    text-decoration: none;
    transition: color 0.3s ease;
}

.footer-menu li a:hover {
    color: #ea8500;
}

.copyright-area {
    background-color: #1c1b1b;
    padding: 15px 0;
    color: #d5d5d5;
    text-align: center;
    div{
        margin: 0 auto!important;
    }
}
.copyright{
    display: flex;
    justify-content: center;
}
@media (max-width: 767px) {
    .footer-menu {
        margin-top: 30px;
    }
}
.btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        background-image: radial-gradient(at center center, #25D366 10%, #0dd134 90%);
        width: 56px;
        height: 56px;
        padding: 10px;
        font-size: 16px;
        border-radius: 100%;
        text-decoration: none;
        animation: pulse 2s infinite;
        box-shadow: 0px 0px 21px -6px #25D366;
        // animation: pisca 1.5s infinite;
        transition: background-color 0.3s ease;
        border: 0;
        position: fixed;
        bottom: 2vh;
        right: 5vw;
        font-size: 0; /* esconde o texto */
        & svg{
                width: 32px;
                height: 32px;
            }
        @media only screen and (max-width: 600px) {
            font-size: initial;
            width: 80vw;
            border-radius: 48px;
            left: 8vw;
        }
        z-index: 1000;
    }

    .whatsapp-button:hover {
        background-color: #128C7E;
    }

    .whatsapp-button i {
        margin-right: 10px;
        font-size: 20px;
    }
</style>
